<div class="row-acc">
      <!-- ÜST SATIR: buton + diğer tagler -->
      <div class="row-acc__top">
        <ng-content select="[row]"></ng-content>
      </div>

      <!-- ALT PANEL: tüm satırı kaplar -->
      <div class="row-acc__panel" [@expandCollapse]="isOpen() ? 'open' : 'closed'">
        <ng-content select="[content]"></ng-content>
      </div>
    </div>
